import React from "react";
import "./confirmation.css";
import { Link, useLocation } from "react-router-dom";
import { Button } from "antd";
import { useTranslation } from "react-i18next";



interface Data {
  companyName: string;
  idNumber: string;
  requestId: string;
  taxNumber: string;
  address: string;
  place: string;
  responsiblePersonFullName: string;
  responsiblePersonFunction: string;
  companyEmailAddress: string;
  companyPhoneNumber: string;
  contactPersonFirstName: string;
  contactPersonLastName: string;
  contactPersonEmail: string;
  languageId: string;
}





const ConfirmationPage = () => {
  const location = useLocation();
  const { t } = useTranslation();

  const titleMapping: { [key: string]: string } = {
    // Contact Information
    contactPersonFirstName:t(
      "register:first-name",
      "First Name"
    ),
    contactPersonLastName: t(
      "register:last-name",
      "Last Name"
    ),
    contactPersonEmail: t("register:email-address", "Email address"),
    companyPhoneNumber: t("global.phone-number", "Phone number"),
    receiveNews: t("register:i-would-like-to-receive-news", "I would like to receive news"),
    hasVatIdAndAcceptsTerms: t(
      "register:i-have-vat-id-and-accept-terms-conditions",
      "I have VAT ID and accept Terms & Conditions"
    ),
  
    // Company Information
    companyName: t("requests:create.company-name", "Company Name"),
    requestId: t("request:request-id", "ID zahtjeva"),
    taxNumber: t("requests:create.tax-number", "Tax Number"),
    countryId: t("register:country", "Country"),
    companyAddress: t("global.address", "Address"),
    address: t("global.address", "Address"),
    place: t("register:city", "City"),
    postCode: t("register:postal-code", "Postal Code"),
    companyEmailAddress: t(
      "request:create.primary-email",
      "Company Primary E-mail"
    ),
    smtNumber:t("request:create.smt-number", "SMT Number"),
    cipCidNumber:t("request:create.cip-cid-number", "CIP/CID Number"),
    aconNumber:t("request:create.acon-number", "ACON No"),
    vatNumber:t("request:create.vat-number", "VAT Number"),
    roadLog:t("request:create.road-log", "Road LOG"),
  
    // Questionnaire (Fleet/Logistics)
    vehicalFleet: t("request:total-vehicle-fleet","Total Number of Fleet Vehicles"),
    trailers: t("request:trailer-type","Trailers (by Type)"),
    specialLicence: t("request:special-license","Special License"),
    cemtPermits: t("request:cemt-permits","CEMT Permits"),
    certifications: t("request:certifications","Certifications & Licenses"),
    operatingCountries: t("request:operating-countries","Operating Countries"),
  
    // Questionnaire (Shipping Specific)
    shipFrequency: t("request:ship-frequency","How often do you ship?"),
    plannedGoods: t("request:planned-goods","What goods are you planning to ship?"),
    shipmentSize:t("request:shipment-size","What size are your shipments?"),
  };
  

  const data = location.state as Data;
  
  const {
    ...filteredData
  } = data;


  const printDocument = () => {
    // Open the print dialog
    window.print();
  };

  return (
    <div className="confirmation-container">
      <h1 className="title-confirm">{t("request:submission-confirmation","Submission Confirmation: Entry Received")}</h1>

      <div className="success-alert">
        <h1>{t("request:success","Success!")}</h1>
      </div>

      <section id="printable-section">
        <div className="container-data">
                 <table>
            {Object.entries(filteredData).map(([key, value]: any) => (
              <tr key={key}>
                <th style={{ width: "30%" }}>{titleMapping[key] || key}</th>
                <td>
                  {Array.isArray(value) ? (
                    value.length > 0 ? (
                      typeof value[0] === "object" ? (
                        // ✅ Case 1: Array of objects → Table with headers
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                          <thead>
                            <tr>
                              {Object.keys(value[0]).map((header) => (
                                <th
                                  key={header}
                                  style={{
                                    border: "1px solid #ddd",
                                    padding: "6px",
                                    textAlign: "left",
                                    background: "#f5f5f5",
                                  }}
                                >
                                  {titleMapping[header] || header}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {value.map((item: any, idx: number) => (
                              <tr key={idx}>
                                {Object.values(item).map((val: any, i) => (
                                  <td
                                    key={i}
                                    style={{ border: "1px solid #ddd", padding: "6px" }}
                                  >
                                    {val}
                                  </td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      ) : (
                        // ✅ Case 2: Array of strings/numbers → Single-column table
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                          <thead>
                            <tr>
                              <th
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "6px",
                                  textAlign: "left",
                                  background: "#f5f5f5",
                                }}
                              >
                                {titleMapping[key] || key}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {value.map((item: any, i: number) => (
                              <tr key={i}>
                                <td style={{ border: "1px solid #ddd", padding: "6px" }}>
                                  {item}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )
                    ) : (
                      "-"
                    )
                  ) : typeof value === "boolean" ? (
                    // ✅ Case 3: Boolean → Yes/No
                    value ? "Yes" : "No"
                  ) : (
                    // ✅ Case 4: String/Number → Direct value
                    value
                  )}
                </td>
              </tr>
            ))}

          </table>

        </div>
      </section>

      <div className="section-container flex flex-col md:flex-row w-full mt-4">
        <div className="flex justify-end flex-col md:flex-row w-full">
          <Button
            className="btn-next bg-white mb-3 md:mb-0 flex justify-center mt-3"
            type="default"
            size="large"
            onClick={printDocument}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0110.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0l.229 2.523a1.125 1.125 0 01-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0021 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 00-1.913-.247M6.34 18H5.25A2.25 2.25 0 013 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 011.913-.247m10.5 0a48.536 48.536 0 00-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5zm-3 0h.008v.008H15V10.5z"
              />
            </svg>
            <span className="ml-4">{t("request:print","Print")}</span>
          </Button>
          <Button
            className="btn-next bg-blue-500 ml-0 md:ml-4 mt-3"
            type="primary"
            size="large"
          >
            <Link to="/">{t("request:go-to-homepage","Go to home page")}</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPage;
